import React from "react";
import "./Project.css";
import { motion } from "framer-motion";

const variants = {
  hidden: {
    opacity: 0,
  },
  show: {
    opacity: 1,
  },
};

const Project = ({ image, description, link }) => {
  return (
    <motion.a
      variants={variants}
      className="project"
      href={link}
      target="_blank"
      rel="noopener noreferrer"
    >
      <img src={image} alt={description} />
      <p className="project-title">{description}</p>
    </motion.a>
  );
};

export default Project;
